/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateJobAdTemplate } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { JobAdTemplate } from '@coin/shared/core/util-models-v2';
import { PageOfJobAdTemplateListItem } from '@coin/shared/core/util-models-v2';
import { UpdateJobAdTemplate } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateJobAdTemplatesParams {
  createJobAdTemplate?: CreateJobAdTemplate;
}

export interface DeleteJobAdTemplatesParams {
  id: string;
}

export interface DuplicateJobAdTemplatesParams {
  id: string;
}

export interface GetJobAdTemplatesParams {
  id: string;
}

export interface GetRuleFieldValuesJobAdTemplatesParams {
  /** The field to resolve, named as the search scope offers it. */
  field: string;
}

export interface GetRuleSearchScopeJobAdTemplatesParams {
  /** Optional filter on the field names. Omit it to get the whole scope. */
  searchQuery?: string;
}

export interface PageJobAdTemplatesParams {
  page?: number;
  size?: number;
  search?: string;
  status?: 'Draft' | 'Published' | 'Retired';
}

export interface PublishJobAdTemplatesParams {
  id: string;
}

export interface RetireJobAdTemplatesParams {
  id: string;
}

export interface UpdateJobAdTemplatesParams {
  id: string;
  updateJobAdTemplate?: UpdateJobAdTemplate;
}

@Injectable({
  providedIn: 'root'
})
export class HeadcountJobAdTemplatesService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createJobAdTemplates(
    requestParameters?: CreateJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdTemplate>;
  public createJobAdTemplates(
    requestParameters?: CreateJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdTemplate>>;
  public createJobAdTemplates(
    requestParameters?: CreateJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdTemplate>>;
  public createJobAdTemplates(requestParameters?: CreateJobAdTemplatesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/headcount/job-ad-templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createJobAdTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteJobAdTemplates(
    requestParameters?: DeleteJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteJobAdTemplates(
    requestParameters?: DeleteJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteJobAdTemplates(
    requestParameters?: DeleteJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteJobAdTemplates(requestParameters?: DeleteJobAdTemplatesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteJobAdTemplates', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/master/headcount/job-ad-templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateJobAdTemplates(
    requestParameters?: DuplicateJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdTemplate>;
  public duplicateJobAdTemplates(
    requestParameters?: DuplicateJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdTemplate>>;
  public duplicateJobAdTemplates(
    requestParameters?: DuplicateJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdTemplate>>;
  public duplicateJobAdTemplates(
    requestParameters?: DuplicateJobAdTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('duplicateJobAdTemplates', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/headcount/job-ad-templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getJobAdTemplates(
    requestParameters?: GetJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdTemplate>;
  public getJobAdTemplates(
    requestParameters?: GetJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdTemplate>>;
  public getJobAdTemplates(
    requestParameters?: GetJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdTemplate>>;
  public getJobAdTemplates(requestParameters?: GetJobAdTemplatesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('getJobAdTemplates', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/headcount/job-ad-templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * The values a field of the job ad template rule scope may be authored against — the country titles behind &#x60;Country&#x60;, the enum members behind &#x60;State&#x60;, and so on.
   * Carries the same requirement as the search-scope endpoint above, for the same reason: the two are called together to populate one dialog.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRuleFieldValuesJobAdTemplates(
    requestParameters?: GetRuleFieldValuesJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<string>>;
  public getRuleFieldValuesJobAdTemplates(
    requestParameters?: GetRuleFieldValuesJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<string>>>;
  public getRuleFieldValuesJobAdTemplates(
    requestParameters?: GetRuleFieldValuesJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<string>>>;
  public getRuleFieldValuesJobAdTemplates(
    requestParameters?: GetRuleFieldValuesJobAdTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const field = requestParameters?.field;
    this.checkRequired('getRuleFieldValuesJobAdTemplates', { field });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/headcount/job-ad-templates/rule-engine/field-values/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * The rule-engine search scope for job ad template rulesets: the fields a ruleset may be conditioned on, the operators each supports and the type its values carry — everything the rule dialog needs to author one.
   * Use this instead of the approval-workflows workflow-factory search-scope endpoint. That one describes a flat workflow read model, while job ad rulesets are evaluated against the position request itself, so it offers fields that cannot be evaluated here — a rule on one of them fails the whole job ad step rather than simply not matching. This scope offers exactly the fields that evaluate.  Readable with the rule-engine\&#39;s own SiemensEnergy.COIN.Users.Contracts.Enums.Resource.RuleSets right as well, since every consumer that may author rule sets needs this field metadata to do so — the ruleset itself is persisted through SiemensEnergy.COIN.Client.Api.Controllers.RuleEngine.RuleSetsController, which is gated on that right. Same requirement as the field-values endpoint below, which the dialog always calls alongside this one.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRuleSearchScopeJobAdTemplates(
    requestParameters?: GetRuleSearchScopeJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getRuleSearchScopeJobAdTemplates(
    requestParameters?: GetRuleSearchScopeJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getRuleSearchScopeJobAdTemplates(
    requestParameters?: GetRuleSearchScopeJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getRuleSearchScopeJobAdTemplates(
    requestParameters?: GetRuleSearchScopeJobAdTemplatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/headcount/job-ad-templates/rule-engine/search-scope`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { searchQuery: requestParameters?.searchQuery }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageJobAdTemplates(
    requestParameters?: PageJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfJobAdTemplateListItem>;
  public pageJobAdTemplates(
    requestParameters?: PageJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfJobAdTemplateListItem>>;
  public pageJobAdTemplates(
    requestParameters?: PageJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfJobAdTemplateListItem>>;
  public pageJobAdTemplates(requestParameters?: PageJobAdTemplatesParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/master/headcount/job-ad-templates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        search: requestParameters?.search,
        status: requestParameters?.status
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishJobAdTemplates(
    requestParameters?: PublishJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdTemplate>;
  public publishJobAdTemplates(
    requestParameters?: PublishJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdTemplate>>;
  public publishJobAdTemplates(
    requestParameters?: PublishJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdTemplate>>;
  public publishJobAdTemplates(requestParameters?: PublishJobAdTemplatesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('publishJobAdTemplates', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/headcount/job-ad-templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public retireJobAdTemplates(
    requestParameters?: RetireJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdTemplate>;
  public retireJobAdTemplates(
    requestParameters?: RetireJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdTemplate>>;
  public retireJobAdTemplates(
    requestParameters?: RetireJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdTemplate>>;
  public retireJobAdTemplates(requestParameters?: RetireJobAdTemplatesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('retireJobAdTemplates', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/master/headcount/job-ad-templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/retire`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateJobAdTemplates(
    requestParameters?: UpdateJobAdTemplatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAdTemplate>;
  public updateJobAdTemplates(
    requestParameters?: UpdateJobAdTemplatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAdTemplate>>;
  public updateJobAdTemplates(
    requestParameters?: UpdateJobAdTemplatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAdTemplate>>;
  public updateJobAdTemplates(requestParameters?: UpdateJobAdTemplatesParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateJobAdTemplates', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/master/headcount/job-ad-templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateJobAdTemplate,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
